import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="font-label text-sm font-medium text-primary-600">追剧小课堂</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题 · 关于追更你应该知道的
          </h2>
          <p className="mx-auto mt-3 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">
            第一次来韩剧TV？下面这些是大家问得最多的几个问题，点开标题即可查看回答。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-300 bg-background-100/60" : "border-background-200/70 bg-background-50"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                {open && (
                  <div className="px-4 pb-4 md:px-5">
                    <p className="font-body text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}